import { render, staticRenderFns } from "./FAQEntry.vue?vue&type=template&id=3a0a0f6c&scoped=true&"
import script from "./FAQEntry.vue?vue&type=script&lang=ts&"
export * from "./FAQEntry.vue?vue&type=script&lang=ts&"
import style0 from "./FAQEntry.vue?vue&type=style&index=0&id=3a0a0f6c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0a0f6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VIcon})
